import React, { Component } from "react";
import { Route } from "react-router-dom";

// Components
import ErrorBoundary from "components/Common/ErrorBoundary/ErrorBoundary";
import Can from "components/Common/Can/Can";
import NoAccess from "../NoAccess/NoAccess";

type Props = {
    exact: boolean;
    path: string;
    permissions: string[] | string;
    render: (props: any) => JSX.Element;
};

export default function PrivateRenderRoute({
    exact,
    path,
    permissions,
    render,
}: Props): JSX.Element {
    return (
        <ErrorBoundary key={String(window.location)} goBack>
            <Route
                exact={exact}
                path={path}
                render={(routeProps) => (
                    <Can
                        permissions={permissions}
                        yes={render(routeProps)}
                        no={<NoAccess />}
                    />
                )}
            />
        </ErrorBoundary>
    );
}
